
const { NIMBUS_DATA_TYPES } = require('../nimbus-data-types');

module.exports = {
  displayName: 'Open Indent RFQ',
  description: 'When this config is set true, it enables the user to create open indent with rfq option on the indents create page',
  sortOrder: 1,
  name: 'openIndentRFQ',
  documentKey: 'open_indent_rfq',
  values: {
    open_indent_rfq: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'Open Indent RFQ',
      documentKey: 'open_indent_rfq',
    },
  },
};
